import { Map } from 'immutable';
import { constants } from '@saucelabs/sl-component-baseline-chart';
import { constants as performanceConstants } from '@saucelabs/sl-module-performance';

const { PERFORMANCE_TYPE } = performanceConstants;

export const CHART_COLOR_MAP = {
  ...constants.chartColors,
  greyLight: '#D8DDE3',
};

export const CHART_OPTIONS_MAP = Map({
  showBaseline: Map({
    title: '*Show Baseline',
  }),
});

export const METRICS_HISTORY_DATA_SIZE = 1000;
export const RIGHT_AXIS_METRICS = [['requestsCount'], ['speedIndex'], ['score']];
export const MAX_SELECTED_BASELINE = 30;
export const DATE_FORMAT = 'dd:MM:yyyy-HH:mm:ss';
export const DEFAULT_SELECTED_METRICS = {
  [PERFORMANCE_TYPE.HARD]: [{ name: 'load', axis: 0 }],
  [PERFORMANCE_TYPE.JANK]: [{ name: 'scriptingTime', axis: 0 }],
};
